const cadastro_de_solicitacao_de_servico = [
  {
    path: "/cadastro-de-solicitacao-de-servico",
    redirect: "",
    meta: {
      breadCrumb: "Gestão - Manutenção de Matrículas",
    },
    children: [
      {
        path: "/cadastro-de-solicitacao-de-servico",
        name: "cadastro_de_solicitacao_de_servico",
        component: () =>
          import(
            "@/views/CadastroDeSolicitacaoDeServico/CadastroDeSolicitacaoDeServicoHome.vue"
          ),
      },
      {
        path: "/cadastro-de-solicitacao-de-servico/novo",
        name: "cadastro_de_solicitacao_de_servico_novo",
        component: () =>
          import(
            "@/views/CadastroDeSolicitacaoDeServico/CadastroDeSolicitacaoDeServicoNovo.vue"
          ),
      },
      {
        path: "/cadastro-de-solicitacao-de-servico/:id/editar",
        name: "cadastro_de_solicitacao_de_servico_editar",
        component: () =>
          import(
            "@/views/CadastroDeSolicitacaoDeServico/CadastroDeSolicitacaoDeServicoEditar.vue"
          ),
      },
      {
        path: "/cadastro-de-solicitacao-de-servico/:id/visualizar",
        name: "cadastro_de_solicitacao_de_servico_visualizar",
        component: () =>
          import(
            "@/views/CadastroDeSolicitacaoDeServico/CadastroDeSolicitacaoDeServicoVisualizar.vue"
          ),
      },
    ],
  },
];

export { cadastro_de_solicitacao_de_servico };
